module.exports = __webpack_public_path__ + "img/rasterized-gradient-yellow-400.ac70204.png";